import { isPlaceholderLot } from '@trackeat/shared';

export function applySupplierLotPreference<T extends { batch_lot: string; lot_ack: boolean; lot_ack_from_supplier?: boolean }>(lines: T[], noLot: boolean): T[] {
  return lines.map((line) => {
    const missing = !line.batch_lot.trim() || isPlaceholderLot(line.batch_lot);
    if (noLot && missing && !line.lot_ack) return { ...line, lot_ack: true, lot_ack_from_supplier: true };
    if (!noLot && line.lot_ack_from_supplier) return { ...line, lot_ack: false, lot_ack_from_supplier: false };
    return line;
  });
}
